export const GLOBAL_STATE = 'Guests' as const

export const GUEST_LIST = 'GUEST_LIST' as const
export const GUEST_ALL = 'GUEST_ALL' as const
export const GUEST_DELETE_COURSE = 'GUEST_DELETE_COURSE' as const
